module.exports = __webpack_public_path__ + "static/media/share-desktop_disabled_dark.ff66f45c.svg";